const axios = require('axios')
const pz = require('./formats/piezometer')
const inc = require('./formats/inclinometers')

module.exports = async function (idPoint, idProject)  {
    var file = await getFile(idProject, idPoint)
    if (file != null) {
         if (file.typePoint === 'Inclinometro') {
             var readingsInc = await inc(file.path)
             return readingsInc
         } else if (file.typePoint === 'Piezometro Casagrande') {
             var readingsInc = await pz(file.path, 'pz-cg')
             return readingsInc
         } else if (file.typePoint === 'Piezometro Hilo Vibratil') {
             var readingsInc = await pz(file.path, 'pz-hv')
             return readingsInc
         } else {
             return 'DEFAULT'
         }
     }

}

 async function getFile(idProject, idPoint) {
     var tmpObj
     await axios
         .post("https://safe-net.co/data/api/list-tags-forProject/" + idProject)
         .then((result) => {
             var obj = result.data.filter(file => file.point == idPoint && file.tag == "Data")
             if (obj.length > 0) {
                var tmp = obj[obj.length - 1]
                tmpObj = tmp
            } else {
                console.log("Null...")
            }
        })
    return tmpObj
 }

